import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const headerReveal = useScrollReveal({
    threshold: 0.2
  });
  const faqsReveal = useScrollReveal({
    threshold: 0.1
  });
  const faqs = [{
    question: 'Is this going to make me feel weird or "medicated"?',
    answer: 'No. Saffron doesn\'t force your brain into an artificial state like stimulants do. It supports your brain\'s natural calm-focus-regulate cycle — the way God designed it. Most women describe the feeling as "quiet clarity" — like the mental static finally turned off. You still feel like yourself. Just... the calm, clear version.'
  }, {
    question: "I've tried so many supplements. Why would this be different?",
    answer: "Because most supplements only target one piece of the puzzle. A calming herb here. A focus booster there. Saffron's three active compounds (crocin, safranal, and crocetin) work together to support the ENTIRE calm-focus-regulate circuit that breaks down with ADHD-style overwhelm. It's not another random ingredient — it's the missing piece that connects the others."
  }, {
    question: 'How long until I notice something?',
    answer: 'Many women notice a subtle "quieting" within the first week — less mental noise, fewer emotional spikes. By week 2-3, the bigger shifts often show up: staying present with your kids, actually finishing your Bible study, not snapping at your husband over small things. The clinical research shows continued improvement through 8 weeks of consistent use.'
  }, {
    question: 'Is this safe? Can I take it with other supplements or medications?',
    answer: "Saffron has been used for thousands of years and is well-studied for safety. Our formula uses clinically-researched dosing. That said, if you're currently on medications — especially antidepressants or anxiety medications — please talk to your doctor before adding any supplement."
  }, {
    question: "Is this some kind of 'New Age' thing?",
    answer: "Absolutely not. We're a Christian company built on the belief that God placed healing botanicals in creation for our benefit (Genesis 1:29). Saffron is mentioned in Scripture (Song of Solomon 4:14) and has been used for centuries across cultures. There's nothing mystical here — just a God-made plant backed by modern research, formulated by people who share your faith."
  }, {
    question: "What if it doesn't work for me?",
    answer: "Then you get your money back. Simple. We offer a full satisfaction guarantee because we know this works — and we want you to experience it risk-free. If you don't feel calmer, clearer, and more present within 30 days, just reach out and we'll refund you completely."
  }];
  return <section className="w-full bg-[#f5f1ed] py-16 lg:py-24" data-id="element-85">
      <div className="max-w-4xl mx-auto px-6 lg:px-12" data-id="element-86">
        {/* Section Header */}
        <div ref={headerReveal.ref} className={`text-center mb-12 transition-all duration-1000 ${headerReveal.isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`} data-id="element-87">
          <h2 className="font-serif text-3xl lg:text-4xl font-bold text-[#2d4a3a] mb-4" data-id="element-88">
            QUESTIONS YOU'RE PROBABLY ASKING
          </h2>
        </div>

        {/* FAQ List */}
        <div ref={faqsReveal.ref} className="space-y-4" data-id="element-89">
          {faqs.map((faq, index) => <div key={index} className={`bg-white rounded-xl shadow-md overflow-hidden transition-all duration-700 hover:shadow-lg ${faqsReveal.isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`} style={{
          transitionDelay: `${index * 100}ms`
        }} data-id="element-90">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left" data-id="element-91">
                <h3 className="font-bold text-lg text-[#2d4a3a] pr-4" data-id="element-92">
                  {faq.question}
                </h3>
                <div className="flex-shrink-0 w-8 h-8 rounded-full bg-[#496f58] text-white flex items-center justify-center" data-id="element-93">
                  {openIndex === index ? <MinusIcon className="w-5 h-5" data-id="element-94" /> : <PlusIcon className="w-5 h-5" data-id="element-95" />}
                </div>
              </button>
              {openIndex === index && <div className="px-6 pb-6" data-id="element-96">
                  <p className="text-gray-600 leading-relaxed" data-id="element-97">{faq.answer}</p>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}